import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import AppShell from "../../components/AppShell";
import { api, formatErr } from "../../lib/api";
import { ConfigCard } from "../../components/nutrition/ConfigCard";
import { PlayersCard } from "../../components/nutrition/PlayersCard";
import { DISCLAIMER } from "../../components/nutrition/MacroTable";

export default function AdminNutrition() {
  const [cfg, setCfg] = useState(null);
  const [players, setPlayers] = useState(null);
  const loadPlayers = useCallback(() => api.get("/admin/nutrition/players").then((r) => setPlayers(r.data)).catch((e) => toast.error(formatErr(e))), []);
  useEffect(() => {
    api.get("/admin/nutrition/config").then((r) => setCfg(r.data)).catch((e) => toast.error(formatErr(e)));
    loadPlayers();
  }, [loadPlayers]);
  return (
    <AppShell>
      <div data-testid="admin-nutrition-page">
        <h1 style={{ fontFamily: "Bebas Neue, sans-serif", fontSize: "2rem", letterSpacing: "0.06em", margin: 0 }}>Nutrición</h1>
        <p style={{ color: "#a3a3a3", fontSize: 13, margin: "4px 0 18px" }}>Plan Essential: energía y macronutrientes por tipo de día. {DISCLAIMER}</p>
        {cfg && <ConfigCard cfg={cfg} onSaved={(d) => { setCfg(d); loadPlayers(); }} />}
        {players ? <PlayersCard players={players} onChange={loadPlayers} /> : <div style={{ color: "#a3a3a3", fontSize: 13 }} data-testid="nutri-players-loading">Cargando futbolistas…</div>}
      </div>
    </AppShell>
  );
}
